import { LocalDate, localDateFromDate } from "@flockcover/flock-svc-core-types"
import { Input } from "../Input"

type BaseInputProps = Parameters<typeof Input>[0]

export type DatePickerProps = {
  value?: LocalDate
  dataTestId?: string
  onChange: (val: LocalDate | undefined) => void
  onInvalidChange?: (isInvalid: boolean) => void
  invalidDateMessage?: string
  displayDateInvalid?: boolean
} & Omit<BaseInputProps, "value" | "onChange" | "parse">

export const DatePicker = (props: DatePickerProps) => {
  const { value, onChange, invalidDateMessage, onInvalidChange, displayDateInvalid, error, ...otherProps } = props
  const { timeZone } = Intl.DateTimeFormat().resolvedOptions()
  return (
    <Input<string>
      {...otherProps}
      type="date"
      variant="form"
      value={value}
      error={error}
      onChange={(ev) => {
        if (ev !== value) {
          try {
            const parsedValue = ev ? localDateFromDate(new Date(ev), timeZone) : undefined
            onChange(parsedValue)
            if (onInvalidChange) {
              onInvalidChange(false)
            }
          } catch (ex) {} // eslint-disable-line no-empty
        }
      }}
      validate={(val) => {
        try {
          if (val) {
            localDateFromDate(new Date(val), timeZone)
          }
          return undefined
        } catch (ex) {
          if (onInvalidChange) {
            onInvalidChange(true)
          }
          return displayDateInvalid ? invalidDateMessage : undefined
        }
      }}
    />
  )
}

DatePicker.defaultProps = {
  value: ``,
  dataTestId: undefined,
  onInvalidChange: undefined,
  invalidDateMessage: `Invalid date`,
  displayDateInvalid: true,
}
